import { render } from "./AdminSelect.vue?vue&type=template&id=6332d712&scoped=true&ts=true"
import script from "./AdminSelect.vue?vue&type=script&lang=ts"
export * from "./AdminSelect.vue?vue&type=script&lang=ts"

import "./AdminSelect.vue?vue&type=style&index=0&id=6332d712&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6332d712"]])

export default __exports__